<template>
  <mdb-modal :show="show" @close="close()">
    <mdb-modal-header class="aqua-gradient">
      <mdb-modal-title>Select Relation Type</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="overflow-hidden d-flex">
      <mdb-container>
        <mdb-select
          append-to-body
          outline
          search
          style="z-index: 1000;"
          class="no-margin-select mt-3"
          label="Relationship Type"
          :visible-options="10"
          v-model="typesModel"
          @getValue="type = $event"
        />
        <mdb-select
          size="sm"
          label="Direction"
          v-model="directions"
          @getValue="direction = $event"
        />
      </mdb-container>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn
        :disabled="!type || !direction"
        rounded
        size="sm"
        gradient="aqua"
        @click.native="close(type, direction)"
        title="Submit relationship type and direction"
      >Select</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbContainer,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
  mdbSelect
} from 'mdbvue'
import Bridge8Autocomplete from './Bridge8Autocomplete'
import {mapActions} from 'vuex'
import {RelationshpDirections} from '../enums'
import {errorCatch} from '../utils'

export default {
  name: 'AdminSelectRelationTypeModal',
  data () {
    return {
      types: [],
      typesModel: [],
      type: '',
      directions: [
        {text: 'Incoming', value: RelationshpDirections.INCOMING},
        {text: 'Outgoing', value: RelationshpDirections.OUTGOING}
      ],
      direction: null,
      show: false,
      callback: obj => { console.log(`Type selected: ${[obj.type, obj.direction].join(', ')}`) }
    }
  },
  methods: {
    ...mapActions(['apiGetRelationshipTypes']),
    calculateTypesModel () {
      this.typesModel = this.types.map(t => {
        return { text: t, value: t, selected: this.type === t }
      })
    },
    close (type = null, direction = null) {
      this.show = false
      if (typeof type === 'string' && Object.values(RelationshpDirections).includes(direction)) {
        this.callback({type: type, direction: direction})
      }
      this.type = null
      this.direction = null
      this.callback = obj => { console.log(`Type selected: ${[obj.type, obj.direction].join(', ')}`) }
    }
  },
  mounted () {
    this.$bus.$on('admin-modal-select-rel-type', callback => {
      this.callback = callback
      this.show = true
    })
    this.apiGetRelationshipTypes()
      .then(types => {
        this.types = types
      })
      .catch(errorCatch('Get Relationship Types failed in Select Relationship Type Modal', this))
  },
  watch: {
    type: {
      handler () {
        this.calculateTypesModel()
      }
    },
    types: {
      handler () {
        this.calculateTypesModel()
      },
      deep: true
    }
  },
  components: {
    mdbContainer,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbSelect,
    Bridge8Autocomplete
  }
}
</script>

<style lang="sass">
.modal-body
  max-height: 50vh
</style>



// WEBPACK FOOTER //
// src/components/AdminSelectRelationTypeModal.vue